import React, { Component } from 'react'
import { Collapse } from 'react-bootstrap'

class RelatedDocumentsBodyNavContentCollapsible extends Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsed: this.props.collapsed
    }
  }

  renderIfAllOK() {
    const documentsData = this.props.documentsData
    const title = documentsData.title
    let documentBuffer = []
    if (documentsData.data) {
      if (documentsData.data.length > 0) {
        documentsData.data.forEach((item, index) => {
          documentBuffer.push(
            <li key={index}>
              <a href={item.url} target="_blank" rel="noopener">
                {`"${item.description}"`} <i className="fal fa-external-link-square fa-lg text-primary" />
              </a>
            </li>
          )
        })
      }
    }

    let renderingComponent = null
    if (documentBuffer.length > 0) {
      renderingComponent = (
        <div className="ork-related-documents__collapse">
          <a
            className={`ork-related-documents__collapse__heading ${this.state.collapsed ? 'collapsed' : ''}`}
            role="button"
            data-toggle="collapse"
            onClick={() => this.setState({ collapsed: !this.state.collapsed })}
          >
            <span className="ork-related-documents__collapse__heading__title h4">{title}</span>

            {/* <a class="ork-related-documents__collapse__heading" role="button" data-toggle="collapse" href="#2018-collapseExample-01" aria-expanded="true" aria-controls="2018-collapseExample-01">
              <span class="ork-related-documents__collapse__heading__title h4">Diagnóstico de competitividad del País Vasco 2018</span>
              <span class="ork-related-documents__collapse__heading__toggle"><i class="fal fa-arrow-circle-down fa-2x"></i></span>
            </a> */}

            <span className="ork-related-documents__collapse__heading__toggle">
              <i className="fal fa-arrow-circle-down fa-2x" />
            </span>
          </a>
          <Collapse in={!this.state.collapsed}>
            <div className="ork-related-documents__collapse__body">
              <ul>{documentBuffer}</ul>
            </div>
          </Collapse>
        </div>
      )
    }

    return renderingComponent
  }

  render() {
    return this.renderIfAllOK()
  }
}

export default RelatedDocumentsBodyNavContentCollapsible



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavContentCollapsible/RelatedDocumentsBodyNavContentCollapsible.jsx